export class DataRequestViewModel {
	kioskId: string;
	endDate: string;
	startDate: string;
}

